module.exports = __webpack_public_path__ + "static/media/renovation.8f7048ce.jpg";